<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="395"
      size="mini"
      resizable
      border
      ref="contrinerTable"
      :mouse-config="{ selected: true }"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :edit-rules="validRules"
      @edit-closed="editClosed"
      @edit-actived="editActived"
      :checkbox-config="{ highlight: true, reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
      },
      validRules: {
        customsNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsNo') || '请输入关单号',
          },
        ],
      },
      tableColumns: [
        {
          type: 'seq',
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          title:
            this.$l('INDEX.form_label_containerContractNo') || '外运子单号',
          field: 'containerContractNo',
          width: 110,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
          field: 'editContainerNo',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_poBookContractNo') || 'PO外运单号',
          field: 'poBookContractNo',
          width: 130,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },

        {
          title: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          width: 130,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_customsNo') || '关单号',
          field: 'customsNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_customsNo') || '请输入关单号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_label_bookingNumber') || '订舱单号',
          field: 'bookingNumber',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_bookingNumber') || '请输入订舱单号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_label_fcrNo') || 'FCR NO.',
          field: 'bookingNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_fcrNo') || '请输入FCR NO.',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.table_label_importerPo') || '进口商PO',
          field: 'importerPo',
          width: 130,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.table_label_settlementFactoryName') || '结算工厂',
          field: 'settlementFactoryName',
          width: 200,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_hscode') || 'HSCODE',
          field: 'hscode',
          width: 200,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          visible: this.shipmentStatus === 'S' || this.shipmentStatus === 'M',
          title: this.$l('INDEX.form_consignee') || '收货人',
          field: 'consigneeCode',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'dict-select',
            props: {
              body: { shipmentType: 'C', custCode: this.custCode },
              url: '/factory/shipment/customer/select',
              filterable: true,
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_contractNo') || '合同号',
          field: 'contractNo',
          width: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
      oldData: {},
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.contrinerTable.getTableData() || {}
      return fullData
    },
    async validate() {
      const result = await this.$refs.contrinerTable.validate(true)
      return !result
    },
    editActived({ row }) {
      this.oldData = {}
      this.oldData = { ...row }
    },
    async editClosed({ row }) {
      if (!row.customsNo && row.customsNo != this.oldData.customsNo) {
        this.$message.warning('关单号不能更新为空')
        row.customsNo = this.oldData.customsNo
        return
      }
      if (
        row.customsNo != this.oldData.customsNo ||
        row.bookingNo != this.oldData.bookingNo ||
        row.consigneeCode != this.oldData.consigneeCode ||
        row.bookingNumber != this.oldData.bookingNumber
      ) {
        const params = {
          bookingNo: row.bookingNo,
          bookingNumber: row.bookingNumber,
          customsNo: row.customsNo,
          consigneeCode: row.consigneeCode,
          listBookingContainerPoCode: [row.bookingContainerPoCode],
        }
        this.save(params)
      }
      const result = await this.validEvent()
      if (!result) return result
    },
    reduce(list) {
      const newArr = list.reduce((pre, cur) => {
        !pre.includes(cur) && pre.push(cur)
        return pre
      }, [])
      return newArr
    },
    async save(params) {
      this.loadingOpen()
      this.$api
        .shipmentBookingUpdatePoOneApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
          ...params,
        })
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: '更新成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
          this.$emit('reload')
        })
    },
    async validEvent() {
      const $table = this.$refs.contrinerTable
      const errMap = await $table.validate().catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
    getCheckboxRecords() {
      const data = this.$refs.contrinerTable
        .getCheckboxRecords()
        .map((t) => t.bookingContainerPoCode)
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
